import { AxiosInstance } from 'axios'

import { CreateSessionAddBalanceAIRequest } from '@modules/ai/types/Sessions/requests'
import { AiCheckoutSession } from '@modules/ai/types/Sessions/sessions'

export class AiSessionsService {
  private instance: AxiosInstance

  constructor(instance: AxiosInstance) {
    this.instance = instance
  }

  async createSessionAddBalance(data: CreateSessionAddBalanceAIRequest): Promise<AiCheckoutSession> {
    const response = await this.instance.post(`/ai/sessions/add-balance`, data)

    return response.data
  }
}

export const aiSessionsService = (instance: AxiosInstance) => new AiSessionsService(instance)
